import styled from "@emotion/styled";
import React, { ButtonHTMLAttributes } from "react";

const Button = styled.button`
  display: inline-block;
  appearance: none;
  background: none;
  border: none;
  line-height: 0;
  margin: 0;
  padding: 0;

  &:disabled {
    cursor: not-allowed;
  }
`;

interface ImageButtonProps {
  /** Image source href */
  src: string;

  /** Alternative text for image. Use "" for presentational images */
  alt: string;

  className?: string;
  "data-cy"?: string;

  type?: ButtonHTMLAttributes<HTMLButtonElement>["type"];
  onClick?: ButtonHTMLAttributes<HTMLButtonElement>["onClick"];
  disabled?: ButtonHTMLAttributes<HTMLButtonElement>["disabled"];
}

export default function ImageButton({
  src,
  alt,

  className = "",
  "data-cy": dataCy,

  type = "button",
  onClick,
  disabled,
}: ImageButtonProps) {
  return (
    <Button
      type={type}
      className={className}
      onClick={onClick}
      data-cy={dataCy}
      disabled={disabled}
    >
      <img src={src} alt={alt} />
    </Button>
  );
}
